<template>
  <div id="prod-editor">
    <mt-header fixed title="产品溯源码">
      <router-link :to="'/prod/view?id=' + prodId" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <!-- <div v-if="recordList.length>0" style="background:#f5eaae;color:#db6c05;font-size:0.8rem;padding:0.2rem;">点击下载溯源码</div> -->
    <template v-for="record in recordList">
      <mt-cell :title="'生成日期：' + record.createTime + '，数量：' + record.codeNum" :key="record.id"
        :label="record.remark" value="下载" is-link @click.native="showActionSheet(record.id)"></mt-cell>
    </template>
    <p v-if="recordList.length==0" style="text-align:center;width:100%;color:#999999;">该产品暂无溯源码</p>
    <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
  </div>
</template>

<script>
import Vue from "vue";
import {Toast, Cell, Button, Actionsheet, MessageBox} from "mint-ui";
Vue.component(Actionsheet.name, Actionsheet);

export default {
  components: {Toast, Cell, Button, MessageBox},
  props: ["prodId"],
  data: function() {
    return {
      chooseId: "",
      sheetVisible: false,
      actions: [{
        name: "发送到邮箱",
        method: this.sendFileEmail
      },{
        name: "下载到本地",
        method: this.downloadFile
      }],
      recordList: []
    };
  },
  methods: {
    downloadFile(){
      window.location = this.GLOBAL.serverUrl + "/ent/prod/afcode/" + this.chooseId + "/file";
    },
    sendFileEmail(){
      var $app = this;
      MessageBox.prompt('请输入邮箱').then(({ value, action }) => {
        $app.$http.get($app.GLOBAL.serverUrl + "/ent/prod/afcode/" + $app.chooseId + "/file/email?mailAddr=" + value)
        .then(function(resp) {
          if (resp.body.code == 200){
            Toast({
              message: "溯源码文件已发送到您的邮箱，请注意查收！",
              iconClass: "icon icon-success"
            });
          }
          else if (resp.body.code == 500){
            Toast("邮件发送失败，请稍后再试！");
          }
        });
      });
    },
    showActionSheet(rid){
      this.chooseId = rid;
      this.sheetVisible = true;
    }
  },
  mounted: function() {
    this.$http
      .get(this.GLOBAL.serverUrl + "/ent/prod/" + this.prodId + "/afcode")
      .then(function(resp) {
        if (resp.body.code == 200) this.recordList = resp.body.data;
        else if (resp.body.code == 500)
          Toast("获取数据失败，请稍后再试！");
      });
  }
};
</script>
<style scoped>
#prod-editor {
  padding-top: 40px;
}
a {
  text-decoration: none;
}
.mint-cell-label{
  line-height: 1.5em;
}
.mint-cell-title{
  padding: 0.5rem;
}
</style>